"use client";

import {
  BackButtonUI,
  EndButtonUI,
  ToggleHeaderUI,
  WebChatHeaderUI,
} from "../../components/WebChatHeaderUI";
import { useConversationsStore } from "../../store/conversationsStore";
import { useWebchatStore, Pages } from "../store";
import { useAtom } from "jotai";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

export function WebChatHeader() {
  const {
    use: { deploymentWebchatSettings: settings },
  } = useConversationsStore();

  const {
    use: { page },
  } = useWebchatStore();

  if (!settings) {
    return null;
  }

  return (
    <WebChatHeaderUI
      backButton={page !== Pages.HOME && <BackButton />}
      icon={settings.heading?.icon}
      title={settings.heading?.title}
      subtitle={settings.heading?.subtitle}
      endButton={page === Pages.CHAT && <EndButton />}
      toggleHeader={<ToggleHeader />}
    />
  );
}

function BackButton() {
  const {
    use: { page },
    bind: { setPage },
  } = useWebchatStore();

  const handleClick = useCallback(() => {
    if (page === Pages.CHAT) {
      setPage(Pages.HOME);
    }
  }, [page, setPage]);

  return <BackButtonUI onClick={handleClick} />;
}

function EndButton() {
  const {
    bind: { endConversation },
  } = useConversationsStore();
  const t = useTranslations();

  const {
    bind: { setPage },
  } = useWebchatStore();

  return (
    <EndButtonUI
      onClick={() => {
        endConversation().subscribe();
        setPage(Pages.HOME);
      }}
    >
      {t("Webchat.end_chat")}
    </EndButtonUI>
  );
}

function ToggleHeader() {
  const [visible, setVisible] = useAtom(useWebchatStore().visible);

  return <ToggleHeaderUI toggleVisible={() => setVisible(!visible)} />;
}
